import { fetchTokenAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const blackDuckSca = productVariant({
  identifier: "blackDuckSca",
  authLabel: "Software Composition Analysis",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://blackduck.example.com/api"),
  auth: ({ configuration }) =>
    fetchTokenAuth({
      request: {
        url: {
          from: "literal",
          value:
            (configuration.baseUrl || "https://blackduck.example.com/api")
              .trim()
              .replace(/\/+$/, "") + "/tokens/authenticate",
        },
        headers: [
          {
            name: "Authorization",
            value: { from: "template", template: "token {secrets.apiToken}" },
          },
        ],
      },
      extract: { from: "jsonPath", paths: ["bearerToken"] },
      apply: {
        kind: "header",
        name: "Authorization",
        scheme: "Bearer",
        extraHeaders: [],
      },
    }),
  steps: [
    {
      title: "Set up Black Duck SCA",
      items: [
        {
          kind: "markdown",
          content:
            "Open **My Access Tokens** in Black Duck SCA and create a token with read access. Enter your instance API URL and token below. See [API authentication](https://documentation.blackduck.com/bundle/bd-hub/page/SDK/Using_the_Hub_SDK.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://blackduck.example.com/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Replace the example host with the HTTPS URL of the organization’s Black Duck SCA server. Keep the `/api` prefix; the tenant’s REST API documentation is available at `/api-doc/public.html` and the public OpenAPI specification at `/api-doc/openapi3-public.json`.",
        },
        {
          kind: "input",
          label: "Black Duck SCA API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Generate an API token from the Black Duck SCA user menu’s My Access Tokens page and store it securely; it is exchanged for a bearer token.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://blackduck.example.com/api")
          .trim()
          .replace(/\/+$/, "") + "/projects/?limit=1",
      ...{
        method: "GET",
        headers: {
          Accept: "application/vnd.blackducksoftware.project-detail-4+json",
        },
      },
    }),
  },
});
